import { NgModule, LOCALE_ID } from '@angular/core';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MOMENT_DATE_FORMATS, MomentDateAdapter } from '../../../core/adapters/MOMENT_DATE_FORMATS';
import { MatMomentDateModule } from '@angular/material-moment-adapter';

@NgModule({
	imports: [
		MatDatepickerModule,
		MatMomentDateModule
	],
	providers: [
		{ provide: MAT_DATE_LOCALE, useValue: 'tr-TR' },
		{ provide: LOCALE_ID, useValue: "tr-TR" },
		{ provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
		{ provide: DateAdapter, useClass: MomentDateAdapter }
	]
})
export class MatDateModule { }
